export default {
    key: 'jtp',
    common: {
        productName: 'core.productNames.jtp',
        splashMessage: 'offerFlow.splashMessage.jtp',
        headingAside: 'offerFlow.headingAside.jtp',
    },
    stepDate: {
        heading: 'offerFlow.pages.stepDate.heading.jtp',
        infoModal: {
            heading: 'offerFlow.pages.stepDate.infoModal.heading.jtp',
            body: 'offerFlow.pages.stepDate.infoModal.body.jtp',
        },
    },
    stepPassengers: {
        heading: 'offerFlow.pages.stepPassengers.heading.jtp',
        body: 'offerFlow.pages.stepPassengers.body.withReductions',
    },
} satisfies OfferFlowContent;
